/* istanbul ignore file */
import React from 'react';
import { useFieldHelper, LinkField, FieldProps } from 'framework/ui/field';
import { useJournalEntryUrl } from 'domain/finance/journalEntry/shared/useJournalEntryRouting';

const JournalEntryLink = ({ source, ...props }: FieldProps) => {
  const { getValue } = useFieldHelper({ source });
  const { getSingleEntityUrl } = useJournalEntryUrl();
  const id = getValue();

  return <LinkField linkText={id} isInternal value={id ? getSingleEntityUrl(id) : null} {...props} />;
};

export default JournalEntryLink;
